import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=5ad1e8c6"
import script from "./brand.vue?vue&type=script&lang=ts"
export * from "./brand.vue?vue&type=script&lang=ts"
import style0 from "./brand.vue?vue&type=style&index=0&id=5ad1e8c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports